/* eslint-disable no-plusplus */

import {
  UPLOAD_COMPANY_FILE,
  GET_COMPANY_FILES,
  DELETE_COMPANY_FILE,
  RENAME_COMPANY_FILE,
  GET_COMPANY_FILE,
  CLEAR_COMPANY_FILE,
  ADD_COMPANY_FOLDER_IN_HIERARCHY,
  REMOVE_COMPANY_FOLDER_FROM_HIERARCHY,
  REMOVE_COMPANY_FOLDERS_FROM_HIERARCHY,
  CLEAR_COMPANY_FOLDERS_HIERARCHY,
  CLEAR_COMPANY_STORAGE,
  DELETE_COMPANY_FOLDER,
  ADD_COMPANY_FOLDER,
  GET_COMPANY_FOLDER_DATA,
} from '../actions/companyFilesActions';

const initialState = {
  fetched: null,
  docs: [],
  folders: [],
  files: [],
  foldersHierarchy: [],
  openedFolderId: null,
  parentFolderId: null,
  openedFolderName: '',
  fetchedFile: null,
  filesForPaste: null,
};

let i = 0;

const mapFolders = item => ({
  id: Date.now() + i++,
  itemId: item.id,
  name: item.fold_name,
  type: item.type,
  owner: item.department,
  createdAt: item.created_at,
});

const mapFiles = item => ({
  id: Date.now() + i++,
  itemId: item.id,
  name: item.doc_name,
  type: item.type,
  owner: '',
  createdAt: item.created_at,
  docType: item.doc_type,
  docFile: item.doc_file,
  category: item.location,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case UPLOAD_COMPANY_FILE:
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: Date.now() + i++,
            itemId: action.payload.id,
            name: action.payload.doc_name,
            type: action.payload.type,
            owner: '',
            createdAt: action.payload.created_at,
            docType: action.payload.doc_type,
            docFile: action.payload.doc_file,
            category: action.payload.location,
          },
        ],
      };
    case GET_COMPANY_FILES:
      return {
        ...state,
        docs: action.payload.results,
      };
    case GET_COMPANY_FILE:
      return {
        ...state,
        fetched: action.payload,
      };
    case DELETE_COMPANY_FILE:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
    case RENAME_COMPANY_FILE:
      return state;
    case CLEAR_COMPANY_FILE:
      return {
        ...state,
        fetched: null,
      };
    case DELETE_COMPANY_FOLDER:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
    case ADD_COMPANY_FOLDER:
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: Date.now() + i++,
            itemId: action.payload.id,
            name: action.payload.fold_name,
            type: action.payload.type,
            owner: action.payload.department,
            createdAt: action.payload.created_at,
          },
        ],
      };
    case GET_COMPANY_FOLDER_DATA:
      return {
        ...state,
        items: [
          ...action.payload.folders.map(mapFolders),
          ...action.payload.storage.map(mapFiles),
        ],
        openedFolderId: action.payload.folder_id,
        openedFolderName: action.payload.folder_name,
        parentFolderId: action.payload.parent_folder_id,
      };
    case CLEAR_COMPANY_STORAGE:
      return {
        ...state,
        fetched: null,
        folders: [],
        files: [],
        foldersHierarchy: [],
        openedFolderId: null,
        parentFolderId: null,
        openedFolderName: '',
      };
    case ADD_COMPANY_FOLDER_IN_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: [...state.foldersHierarchy, action.payload],
      };
    case REMOVE_COMPANY_FOLDER_FROM_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: state.foldersHierarchy.filter(
          item => item.id !== action.payload
        ),
      };
    case REMOVE_COMPANY_FOLDERS_FROM_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: state.foldersHierarchy.filter(
          (_, index) => index <= action.payload
        ),
      };
    case CLEAR_COMPANY_FOLDERS_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: [],
      };
    default:
      return state;
  }
}
